import { render, staticRenderFns } from "./AiTasksSuggestion.vue?vue&type=template&id=37ea934e&scoped=true"
import script from "./AiTasksSuggestion.vue?vue&type=script&lang=js"
export * from "./AiTasksSuggestion.vue?vue&type=script&lang=js"
import style0 from "./AiTasksSuggestion.vue?vue&type=style&index=0&id=37ea934e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea934e",
  null
  
)

export default component.exports